import { render, staticRenderFns } from "./CardSlider.vue?vue&type=template&id=47a12e48&scoped=true&"
import script from "./CardSlider.controller.js?vue&type=script&lang=js&"
export * from "./CardSlider.controller.js?vue&type=script&lang=js&"
import style0 from "./CardSlider.vue?vue&type=style&index=0&id=47a12e48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a12e48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!F:/Projects/Hugo/Ilead/FrontEnd/lbcleadership/Client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
installComponents(component, {VFlex})
